/**
 * @fileoverview PrimaryNavbar component
 *
 * This component will have a clickable button that will toggle the navbar between desktop screen and mobile screen.
 */
import SelectorEngine from '../../utils/dom/selector-engine';
import Modal from '../Modal';

class PrimaryNavbar {
	constructor() {
		this.container = undefined;
		this.showMenu = undefined;
		this.hideMenu = undefined;
		this.userInfoWrapper = undefined;
		this._serchModal = undefined;

		this.initNavigation();
	}

	initNavigation() {
		this.container = SelectorEngine.findOne('.lta-primary-header');

		if (this.container !== null) {
			this.showMenu = SelectorEngine.findOne('.show-menu', this.container);
			this.hideMenu = SelectorEngine.findOne('.hide-menu', this.container);
			this.userInfoWrapper= SelectorEngine.findOne('.user-info', this.container);
			this._serchModal = new Modal(SelectorEngine.findOne('#modalSearch', this.container));

			const navSearchCta = SelectorEngine.findOne('.js-search-modal-trigger', this.container);
			navSearchCta.addEventListener('click', () => {
				this._serchModal.show();
			});

			const searchCta = SelectorEngine.findOne('.js-search--action', this.container);
			searchCta.addEventListener('click', this.redirectToSearch.bind(this))
			this.initShowMenu();
			this.initshowUserMenu();
		}
	}

	initShowMenu() {
		if (this.showMenu !== null && this.hideMenu !== null) {
			this.showMenu.addEventListener("click", this.toggleMenu.bind(this));
			this.hideMenu.addEventListener("click", this.toggleMenu.bind(this));
			SelectorEngine.findOne(".primary-list", this.container).addEventListener("click", this.handleClick.bind(this));
		}
	}

	redirectToSearch(event) {
		const searchInput = SelectorEngine.findOne('.lta-search--input input', this.container);
		const urlToRedirect = event.target.dataset.target;
		if (searchInput.value.trim().length > 0) {
			window.location.href = `${urlToRedirect}?q=${searchInput.value}`;
		}
	}

	handleClick(e){
		if(e.target.dataset && e.target.dataset.target){
			const targetElement= document.querySelector(`#${e.target.dataset.target}`);
			targetElement.classList.toggle("active");
		}
	}

	initshowUserMenu () {
		if(this.userInfoWrapper){
			this.userInfoDetailsWrapper= SelectorEngine.findOne('.user-info-details', this.userInfoWrapper);
			const btn= SelectorEngine.findOne('.lta-primary-navbar-logged-in', this.userInfoWrapper);
			if(btn) {
				document.addEventListener("click", this.hideUserMenu.bind(this));
				btn.addEventListener("click", this.showUserMenuOnClick.bind(this));
			}

		}
	}

	toggleMenu (event) {
		const activeElements= SelectorEngine.find('.active', this.container);
		[...activeElements].forEach((element) => {
			element.classList.remove('active');
		});
		SelectorEngine.findOne(`#${event.target.dataset.toggleId}`, this.container).classList.add('active');
		if(event.target.dataset.targetId){
			SelectorEngine.findOne(`#${event.target.dataset.targetId}`, this.container).classList.add('active');
		}
	}

	showUserMenuOnClick () {
		this.userInfoDetailsWrapper.classList.toggle('active');
	}

	hideUserMenu (e) {
		if(!this.userInfoWrapper.contains(e.target)) {
			this.userInfoDetailsWrapper.classList.remove('active');
		}
	}
}

const globalPrimaryNavbar = new PrimaryNavbar();

export default globalPrimaryNavbar;

